export type Edition = 'bd' | 'internal' | string;

type EditionRule = {
  /**
   * 被禁用的路由 name 列表，命中后路由与菜单都会被隐藏
   */
  disabledRoutes: string[];
  /**
   * 被禁用的功能 key（用于指令/组件渲染控制）
   */
  disabledFeatures: string[];
  /**
   * 被禁用的接口路径或正则（匹配 config.url）
   */
  disabledApis: Array<string | RegExp>;
};

const defaultRule: EditionRule = {
  disabledRoutes: [],
  disabledFeatures: [],
  disabledApis: [],
};

const editionKey = (import.meta.env.VITE_APP_EDITION || 'internal').toString();

/**
 * 根据不同版本维护禁用清单，BD 版按需填充
 */
const editionRuleMap: Record<string, EditionRule> = {
  internal: { ...defaultRule, disabledRoutes: [] },
  bd: {
    ...defaultRule,
    // 在此填入 BD 版需要隐藏的路由 name / 功能 key / 接口路径
    // disabledRoutes: ['Protocol', 'Database', 'WorkflowExecutionHistory'],
    // disabledFeatures: [
    //   'tcp_input',
    //   'tcp_output',
    //   'mysql',
    //   'sqlite',
    //   'byte_house',
    //   'milvus',
    //   'protocol',
    //   'backend',
    //   'memory',
    //   'wa-dashboard',
    //   'file-parser',
    //   'conversation-scoring',
    // ],
    disabledApis: [],
  },
};

const activeRule: EditionRule = editionRuleMap[editionKey] || defaultRule;

const isBdEdition = () => editionKey === 'bd';

function isRouteDisabled(name?: string | symbol) {
  if (!name) return false;
  return activeRule.disabledRoutes.includes(String(name));
}

function isFeatureDisabled(key?: string) {
  if (!key) return false;
  return activeRule.disabledFeatures.includes(key);
}

function isApiDisabled(url?: string) {
  if (!url) return false;
  return activeRule.disabledApis.some((rule) => {
    if (typeof rule === 'string') {
      return url.startsWith(rule);
    }
    return rule.test(url);
  });
}

export default function useEdition() {
  return {
    edition: editionKey,
    isBdEdition,
    isRouteDisabled,
    isFeatureDisabled,
    isApiDisabled,
    rule: activeRule,
  };
}
